import React, {useState, useRef, useEffect} from "react";
import "./Accordeon.scss";

function Accordeon({title, children, expanded}) {
  // state
  const [open, setOpen] = useState(expanded || false);
  // reference to content
  const refContent = useRef();

  // side effect (open changed)
  useEffect(() => {
    const content = refContent.current;
    if(content) {
      if(!open) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    }
  }, [open]);

  // click event
  const onClick = () => {
    setOpen(!open);
  }

  // render
  return (
    <div className="c-accordeon">
      <div className="c-accordeon-header" onClick={onClick}>
        <div className="c-accordeon-header-title">{title}</div>
        <div className={`c-accordeon-header-toggle ${open ? "open" : "close"}`}>
          <div className="horizontal"></div>
          <div className="vertical"></div>
        </div>
      </div>
      <div className="c-accordeon-content" ref={refContent}>
        <div className="c-accordon-content-inner">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Accordeon